
	<div *ngIf="msg.msg" class="alert alert-dismissible" 
  [class.alert-success]="msg.msgType=='success'" 
  [class.alert-danger]="msg.msgType=='error'" 
  [class.alert-warning]="msg.msgType=='warning'" 
  [class.alert-info]="msg.msgType=='info'" 
  role="alert" style="margin:0px;">
		<button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="msg.msg=''"><span aria-hidden="true">&times;</span></button>	
		<span *ngIf="msg.isHTML" [innerHTML]="msg.msg"></span>
		<span *ngIf="!msg.isHTML">{{msg.msg}}</span>
	</div>